var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4889 18.2632C11.4889 18.6658 11.5299 19.0566 11.5812 19.4474H2.25748C1.71341 19.4474 1.19162 19.1978 0.806904 18.7537C0.422187 18.3095 0.206055 17.7071 0.206055 17.0789V2.86842C0.206055 1.55395 1.11894 0.5 2.25748 0.5H8.41177L10.4632 2.86842H18.6689C19.213 2.86842 19.7348 3.11795 20.1195 3.56212C20.5042 4.00628 20.7203 4.6087 20.7203 5.23684V12.1171C20.0947 11.7026 19.4074 11.4184 18.6689 11.2645V5.23684H2.25748V17.0789H11.5812C11.5299 17.4697 11.4889 17.8605 11.4889 18.2632ZM18.6689 17.0789V13.5263H16.6175V17.0789H13.5403V19.4474H16.6175V23H18.6689V19.4474H21.7461V17.0789H18.6689Z",
    fill: "#ECECEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFolder);
export default __webpack_public_path__ + "static/media/AddFolder.adaa7d639ef5b0c63012fa3f14c9107b.svg";
export { ForwardRef as ReactComponent };